import React from 'react'
import {List, Typography} from '@material-ui/core';
import PropTypes from 'prop-types';
import Dialog from 'components/Dialog';
import Tr from 'translations/Translations'
import GridBlock from 'components/GridBlock';
import ListElement from './ListElement';
import Loading from "../../Loading";
import SingleButton from "../components/SingleButton";
import {connect} from "react-redux";


function ChangeHistory(
    {
        open,
        onClose,
        historyTab,
        purchasingGroupHeader
    }) {

    const createTab = () => {
        let newHistoryTab = []
        historyTab.forEach(x => {
            let {history, ...other} = x
            history.forEach(inner => {
                newHistoryTab.push({
                    history: inner,
                    owner: {...other}
                })
            });
        });

        let sortTable = newHistoryTab.sort((a, b) => {
            return a.history.operationDatetime - b.history.operationDatetime
        })

        if (sortTable.length === 0) return (
            <Typography>{Tr('empty_history')}</Typography>
        )

        return sortTable.reverse().slice(0, 5).map((item, i) => {
            return (
                <ListElement item={item} key={i} trPrefix={purchasingGroupHeader ? "pg_" : ""}/>
            )
        })
    }

    return (
        <Dialog
            open={open}
            title={Tr('change_history')}
            titleCentered
            maxWidth='md'
            onClose={onClose}
            dialogActions={<SingleButton
                justify='flex-end'
                label={Tr('close')}
                onClick={onClose}/>}
        >
            {!historyTab ?
                <Loading/>
                :
                <GridBlock
                    column
                    alignItems='center'
                >
                    <List>
                        {createTab()}
                    </List>
                </GridBlock>
            }
        </Dialog>
    )
}

ChangeHistory.propTypes = {
    classes: PropTypes.any,
}
export default connect((state) => ({
    purchasingGroupHeader: state.resources.purchasingGroupHeader
}), {

})(ChangeHistory);
